// import { useCallback } from "react";
// import { createValidator } from "../../utils/validation";
// import { 
//     UBOStockExchangeSchema,
//     UBORegulatedEntitySchema,
//     UBOPrivateIndividualSchema,
//     UBOPrivateCompanySchema,
//     UBOPartnershipSchema,
//     UBOPensionFundSchema,
//     UBOTrustSchema,
//     UBOTrustCorporateTrusteeSchema,
//     UBOUnitTrustSchema,
//     UBOUnitTrustIs25PercentHolderYesSchema,
//     UBOFundSchema,
//     UBOFundIsRegulatedFundManagerYesSchema,
//     UBOPublicSectorSchema,
//     UBOFoundationsSchema,
//     UBOFoundationsIsRegulatedYesSchema,
//     UBOSovereignWealthFundsSchema,
//     UBOChruchBodiesSchema,
//     UBOCharitiesSchema,
//     UBOTypeSchema,
//     UBOFundRegulatedFundYesSchema,
//     UBOTrustLegalPersonSchema,
//     UBOTrustNaturalPersonSchema,
//     UBOTrustTypeBeneficiarySchema,
//     UBOTrustClassOfBeneficiariesSchema,
//     UBOTrustProtectorOrControllerYesSchema
//  } from "../validationRules/validateUBOForm";
//  import { useValidateUBOUnitTrustNomineeForm } from "./useValidateUBOUnitTrustNomineeForm";

// export const useValidateUBOForm = () => {

//     const { validateUBOUnitTrustNomineeForm } = useValidateUBOUnitTrustNomineeForm();
    
//     const getCustomValidator = useCallback((formData) => {
//         let customValidator = { };
//         const type = formData.type;
//         const data = formData.data;
//         if (type === "Private Individual (Natural Person)") {
//             customValidator = { ...customValidator, ...UBOPrivateIndividualSchema };
//         } else if (type === "Private Company") {
//             customValidator = { ...customValidator, ...UBOPrivateCompanySchema };
//         } else if (type === "Partnership") {
//             customValidator = { ...customValidator, ...UBOPartnershipSchema };
//         }else if (type === "Company Listed on a Recognised Stock Exchange") {
//             customValidator = { ...customValidator, ...UBOStockExchangeSchema };
//         } else if (type === "Regulated Entity") {
//             customValidator = { ...customValidator, ...UBORegulatedEntitySchema };
//         } else if (type === "Pension Fund") {
//             customValidator = { ...customValidator, ...UBOPensionFundSchema };
//         } else if (type === "Trust") {
//             customValidator = { ...customValidator, ...UBOTrustSchema };

//             if (data && (data.uboTrustType === "Discretionary" || data.uboTrustType === "Accumulation Trust" || data.uboTrustType === "Charitable Trust" || data.uboTrustType === "Pension Trust")) {
//                 customValidator = { ...customValidator, ...UBOTrustClassOfBeneficiariesSchema };
//             }

//             if (data && (data.uboTrustType === "Bare Trust" || data.uboTrustType === "Non-resident Trust")) {
//                 customValidator = { ...customValidator, ...UBOTrustTypeBeneficiarySchema };
//             }

//             if (data && data.uboTrustProtectorOrController === "Yes") {
//                 customValidator = { ...customValidator, ...UBOTrustProtectorOrControllerYesSchema };
//             }

//             if (data && data.uboTrusteeType === "Corporate Trustee") {
//                 customValidator = { ...customValidator, ...UBOTrustCorporateTrusteeSchema };
//             }

//             if (data && data.uboTrusteeType === "Legal Person") {
//                 customValidator = { ...customValidator, ...UBOTrustLegalPersonSchema };
//             }

//             if (data && data.uboTrusteeType === "Natural Person") {
//                 customValidator = { ...customValidator, ...UBOTrustNaturalPersonSchema };
//             }

//         } else if (type === "Unit Trust") {
//             customValidator = { ...customValidator, ...UBOUnitTrustSchema };
//             if (data && data.uboIs25PercentHolder === "Yes") {
//                 customValidator = { ...customValidator, ...UBOUnitTrustIs25PercentHolderYesSchema };
//             }
//         } else if (type === "Fund") {
//             customValidator = { ...customValidator, ...UBOFundSchema };
//             if (data && data.uboIsRegulatedFundManager === "Yes") {
//                 customValidator = { ...customValidator, ...UBOFundIsRegulatedFundManagerYesSchema };
//             }
//             if (data && data.uboRegulatedFund === "Yes") {
//                 customValidator = { ...customValidator, ...UBOFundRegulatedFundYesSchema };
//             }
//         } else if (type === "Public Sector Bodies, governments, state owned companies and local authorities.") {
//             customValidator = { ...customValidator, ...UBOPublicSectorSchema };
//         } else if (type === "Foundations") {
//             customValidator = { ...customValidator, ...UBOFoundationsSchema };
//             if (data && data.uboIsRegulated === "Yes") {
//                 customValidator = { ...customValidator, ...UBOFoundationsIsRegulatedYesSchema };
//             }
//         } else if (type === "Sovereign Wealth Funds") {
//             customValidator = { ...customValidator, ...UBOSovereignWealthFundsSchema };
//         } else if (type === "Church bodies") {
//             customValidator = { ...customValidator, ...UBOChruchBodiesSchema };
//         } else if (type === "Charities") {
//             customValidator = { ...customValidator, ...UBOCharitiesSchema };
//         }
    
//         return customValidator;
//     }, []);

//     const validateUBOForm = (formData) => {
//             // formData is uboState in actual
//             let errors = createValidator(UBOTypeSchema)(formData);
//             const customValidator = getCustomValidator(formData);
//             const generalErrors = createValidator(customValidator)(formData.data);
//             if (formData.type === "Unit Trust") {
//                 console.log("[validation] Unit Trust", formData.data.nominees);
//                 let allNomineeErrors = [];
//                 if (formData.data.nominees) {
//                     for (let nominee of formData.data.nominees) {
//                         allNomineeErrors.push(validateUBOUnitTrustNomineeForm(nominee));
//                     }
//                 }
//                 const allErrors =  { ...errors, ...generalErrors, nomieeErrors: allNomineeErrors };
//                 return allErrors;
//             }

//             return {...errors, ...generalErrors};
    
//         }

//     return { validateUBOForm }

// }




import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { createValidator } from "../../utils/validation";
import {
  UBOStockExchangeSchema,
  UBOStockExchangeRecognisedYesSchema,
  UBORegulatedEntitySchema,
  UBOPrivateIndividualSchema,
  UBOPrivateCompanySchema,
  UBOPrivateCompanyRegulatoryYesSchema,
  UBOPartnershipSchema,
  UBOPartnershipRegulatoryYesSchema,
  UBOPensionFundSchema,
  UBOTrustSchema,
  UBOTrustCorporateTrusteeSchema,
  UBOUnitTrustSchema,
  UBOFundSchema,
  UBOFundIsRegulatedFundManagerYesSchema,
  UBOPublicSectorSchema,
  UBOFoundationsSchema,
  UBOFoundationsIsRegulatedYesSchema,
  UBOSovereignWealthFundsSchema,
  UBOChruchBodiesSchema,
  UBOCharitiesSchema,
  UBOTypeSchema,
  UBOFundRegulatedFundYesSchema,
  UBOTrustLegalPersonSchema,
  UBOTrustNaturalPersonSchema,
  UBOTrustTypeBeneficiarySchema,
  UBOTrustClassOfBeneficiariesSchema,
  UBOTrustProtectorOrControllerYesSchema,
  UBOTrustDeedNotObtainedSchema
} from "../validationRules/validateUBOForm";

export const useValidateUBOForm = () => {
  const location = useLocation();

  // 👇 Only replace "UBO" with "Manager" if on /management-structure
  const messageTransformer = (msg) => {
    if (location.pathname === "/management-structure") {
      return msg.replace(/UBO/gi, "Manager");
    }
    return msg;
  };

  const getCustomValidator = useCallback((formData) => {
    let customValidator = {};
    const type = formData.type;
    const data = formData.data;

    if (type === "Private Individual (Natural Person)") {
      customValidator = { ...customValidator, ...UBOPrivateIndividualSchema };
    } else if (type === "Private Company") {
      customValidator = { ...customValidator, ...UBOPrivateCompanySchema };
      if (data?.uboRegulatory === "Yes") {
        customValidator = { ...customValidator, ...UBOPrivateCompanyRegulatoryYesSchema };
      }
    } else if (type === "Partnership") {
      customValidator = { ...customValidator, ...UBOPartnershipSchema };
      if (data?.uboRegulatory === "Yes") {
        customValidator = { ...customValidator, ...UBOPartnershipRegulatoryYesSchema };
      }
    } else if (type === "Company Listed on a Recognised Stock Exchange") {
      customValidator = { ...customValidator, ...UBOStockExchangeSchema };
      if (data?.uboRecognisedExchange === "Yes") {
        customValidator = { ...customValidator, ...UBOStockExchangeRecognisedYesSchema };
      }
    } else if (type === "Regulated Entity") {
      customValidator = { ...customValidator, ...UBORegulatedEntitySchema };
    } else if (type === "Pension Fund") {
      customValidator = { ...customValidator, ...UBOPensionFundSchema };
    } else if (type === "Trust") {
      customValidator = { ...customValidator, ...UBOTrustSchema };

      if (data && ["Discretionary", "Accumulation Trust", "Charitable Trust", "Pension Trust"].includes(data.uboTrustType)) {
        customValidator = { ...customValidator, ...UBOTrustClassOfBeneficiariesSchema };
      }

      if (data && ["Bare Trust", "Non-resident Trust"].includes(data.uboTrustType)) {
        customValidator = { ...customValidator, ...UBOTrustTypeBeneficiarySchema };
      }

      if (data?.uboTrustProtectorOrController === "Yes") {
        customValidator = { ...customValidator, ...UBOTrustProtectorOrControllerYesSchema };
      }

      if (data?.uboTrusteeType === "Corporate Trustee") {
        customValidator = { ...customValidator, ...UBOTrustCorporateTrusteeSchema };
      }

      if (data?.uboTrusteeType === "Legal Person") {
        customValidator = { ...customValidator, ...UBOTrustLegalPersonSchema };
      }

      if (data?.uboTrusteeType === "Natural Person") {
        customValidator = { ...customValidator, ...UBOTrustNaturalPersonSchema };
      }

      if (data?.uboTrustDeedObtained === "No") {
        customValidator = { ...customValidator, ...UBOTrustDeedNotObtainedSchema };
      }

    } else if (type === "Unit Trust") {
      customValidator = { ...customValidator, ...UBOUnitTrustSchema };
    } else if (type === "Fund") {
      customValidator = { ...customValidator, ...UBOFundSchema };
      if (data?.uboIsRegulatedFundManager === "Yes") {
        customValidator = { ...customValidator, ...UBOFundIsRegulatedFundManagerYesSchema };
      }
      if (data?.uboRegulatedFund === "Yes") {
        customValidator = { ...customValidator, ...UBOFundRegulatedFundYesSchema };
      }
    } else if (type === "Public Sector Bodies, governments, state owned companies and local authorities.") {
      customValidator = { ...customValidator, ...UBOPublicSectorSchema };
    } else if (type === "Foundations") {
      customValidator = { ...customValidator, ...UBOFoundationsSchema };
      if (data?.uboIsRegulated === "Yes") {
        customValidator = { ...customValidator, ...UBOFoundationsIsRegulatedYesSchema };
      }
    } else if (type === "Sovereign Wealth Funds") {
      customValidator = { ...customValidator, ...UBOSovereignWealthFundsSchema };
    } else if (type === "Church bodies") {
      customValidator = { ...customValidator, ...UBOChruchBodiesSchema };
    } else if (type === "Charities") {
      customValidator = { ...customValidator, ...UBOCharitiesSchema };
    }

    return customValidator;
  }, []);

  const validateUBOForm = (formData) => {
    let errors = createValidator(UBOTypeSchema, { messageTransformer })(formData);
    const customValidator = getCustomValidator(formData);
    const generalErrors = createValidator(customValidator, { messageTransformer })(formData.data);

    return { ...errors, ...generalErrors };
  };

  return { validateUBOForm };
};
